














export default {
  name: "BaseWizardSteps",
  props: {
    activeTab: {
      type: Number,
      default: null
    },
    strings: {
      type: Array,
      required: true
    }
  }
};
